import React from 'react'
import { Box, Typography } from '@mui/material'
import WinLoseRule from './WinLoseRule'
import PlayerCorrect from './elements/PlayerCorrect'
import PlayerWrong from './elements/PlayerWrong'
import PlayerComp from './elements/PlayerComp'
import PlayerSpecial from './elements/PlayerSpecial'

const PlayerRule = ({ simple, rule }) => {
  const title = (() => {
    if (rule.team.active) {
      return '個人スコア'
    } else {
      return 'スコア'
    }
  })()

  const correctWrong = rule => (
    <Box className="correct-wrong">
      <Typography variant="body2" className="rule-line">
        <PlayerCorrect simple={simple} rule={rule} />
        <PlayerWrong simple={simple} rule={rule} />
      </Typography>
      <Typography variant="body2" className="rule-line">
        <PlayerComp simple={simple} rule={rule} />
      </Typography>
    </Box>
  )

  const special = rule => (
    <Box className="special">
      <Typography variant="body2" className="rule-line">
        <PlayerSpecial simple={simple} rule={rule} />
      </Typography>
    </Box>
  )

  return (
    <Box className="player-rule">
      <Typography variant="caption">
        <Box component="span" className="rule-caption">{title}</Box>
      </Typography>
      <Box className="content">
        {correctWrong(rule.player)}
        {!rule.board.active && <WinLoseRule simple={simple} rule={rule.player} />}
        {special(rule.player)}
      </Box>
    </Box>
  )
}

export default PlayerRule
